import s from './Question.module.scss';
import { useLanguage } from '../contexts/LanguageContext';
import { QUESTION_TEXT } from '../i18n/question';
import { INSTAGRAM_URL, LINE_URL } from '../config/socialLinks';
import { trackCtaClick } from '../utils/analytics';

const Question = () => {
  const { lang } = useLanguage();
  const t = QUESTION_TEXT[lang] || QUESTION_TEXT.JP;

  return (
    <section className={s.root}>
      <div className={s.hero}>
        <span className={s.subTitle}>
          {t.hero.subTitle}
        </span>

        <h1>
          {t.hero.title}
        </h1>

        <p>
          {t.hero.description}
        </p>
      </div>

      <div className={s.faqList}>
        {t.items.map((item) => (
          <article
            key={item.key}
            className={s.card}
          >
            <div className={s.questionRow}>
              <div className={s.qIcon}>
                Q
              </div>

              <h2>
                {item.question}
              </h2>

              <button
                type="button"
                className={s.arrowButton}
                aria-label={t.openLabel}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            <div className={s.answerRow}>
              <div className={s.aIcon}>
                A
              </div>

              <p>
                {item.answer}
              </p>
            </div>
          </article>
        ))}
      </div>

      <div className={s.cta}>
        <p>
          {t.cta.lines.map((line, index) => (
            <span key={line}>
              {line}
              {index < t.cta.lines.length - 1 && <br />}
            </span>
          ))}
        </p>

        <div className={s.buttons}>
          <a
            href={LINE_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackCtaClick({
              label: 'line_faq',
              placement: 'faq_page',
              destination: LINE_URL,
              destinationType: 'external_booking',
            })}
          >
            {t.cta.buttons.line}
          </a>

          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackCtaClick({
              label: 'instagram_faq',
              placement: 'faq_page',
              destination: INSTAGRAM_URL,
              destinationType: 'external_social',
            })}
          >
            {t.cta.buttons.instagram}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Question;
